export default __webpack_public_path__ + "static/media/Book_5.0748ceaf.pdf";